export function round(value: number, power: true|number|undefined) {
  const round = power === true ? 0 : power
  return typeof round === 'number'
    ? Math.round(value * Math.pow(10, round)) / Math.pow(10, round)
    : value
}
